var map = {
	"./animal-carving/26.png": 94401,
	"./animal-carving/27.png": 33036,
	"./animal-carving/28.png": 91731,
	"./animal-carving/29.png": 46305,
	"./bangle/33.png": 35161,
	"./bangle/34.png": 88945,
	"./bangle/35.png": 43051,
	"./bangle/36.png": 78976,
	"./bangle/37.png": 43566,
	"./bead-caps/41.png": 2755,
	"./bead-caps/42.png": 91602,
	"./bead-caps/43.png": 31912,
	"./bead-caps/44.png": 44311,
	"./bombe-ring/1.png": 82154,
	"./bombe-ring/4.png": 10312,
	"./bombe-ring/6.png": 90953,
	"./bombe-ring/7.png": 20507,
	"./charms/1.png": 43009,
	"./charms/10.png": 1237,
	"./charms/11.png": 96577,
	"./charms/2.png": 37661,
	"./charms/5.png": 94998,
	"./charms/6.png": 57866,
	"./charms/7.png": 44632,
	"./charms/8.png": 71686,
	"./charms/9.png": 2566,
	"./faceted-gemstone-bezel-settings/15.png": 28147,
	"./faceted-gemstone-bezel-settings/16.png": 26217,
	"./faceted-gemstone-bezel-settings/17.png": 6740,
	"./faceted-gemstone-bezel-settings/18.png": 64065,
	"./faceted-gemstone-bezel-settings/8.png": 83962,
	"./flowers/50.png": 33496,
	"./flowers/51.png": 90818,
	"./flowers/52.png": 55217,
	"./flowers/53.png": 2581,
	"./in-person/personal-class/ideacollage.png": 79297,
	"./in-person/rent-a-bench/benches.png": 13079,
	"./in-person/rent-a-bench/sunnybenches.png": 28702,
	"./in-person/rent-a-bench/tools.png": 7370,
	"./in-person/ring-intensive/archrings.png": 64032,
	"./in-person/ring-intensive/firstrings.png": 63158,
	"./in-person/ring-intensive/funrings.png": 94980,
	"./in-person/wax-carving-week/banner.png": 81998,
	"./in-person/wax-carving-week/extra.png": 51856,
	"./in-person/wax-carving-week/poster.png": 96208,
	"./in-person/wax-carving-week/schedule.png": 7374,
	"./in-person/wax-carving-week/summerweek1.png": 85568,
	"./in-person/wax-carving-workshop/rings.png": 51867,
	"./in-person/wax-carving-workshop/waxtosilver.png": 77811,
	"./in-person/wax-carving-workshop/zilverring.png": 56601,
	"./in-person/wax-tryouts/26.png": 63292,
	"./in-person/wax-tryouts/27.png": 15990,
	"./in-person/wax-tryouts/28.png": 78830,
	"./in-person/wax-tryouts/29.png": 35989,
	"./repeating-pattern-rings/19.png": 34040,
	"./repeating-pattern-rings/19old.png": 57047,
	"./repeating-pattern-rings/20.png": 43531,
	"./repeating-pattern-rings/21.png": 78479,
	"./repeating-pattern-rings/22.png": 97738,
	"./ring-from-separate-parts/44.png": 37351,
	"./ring-from-separate-parts/45.png": 59780,
	"./ring-from-separate-parts/46.png": 74258,
	"./ring-from-separate-parts/47.png": 56997,
	"./robot/47.png": 53405,
	"./robot/48.png": 76598,
	"./robot/49.png": 30005,
	"./robot/50.png": 29477,
	"./rosecut-and-cabochon-bezel-settings/10(1).png": 81191,
	"./rosecut-and-cabochon-bezel-settings/11(1).png": 93084,
	"./rosecut-and-cabochon-bezel-settings/12(1).png": 27250,
	"./rosecut-and-cabochon-bezel-settings/13(1).png": 18492,
	"./rosecut-and-cabochon-bezel-settings/14(1).png": 56799,
	"./rosecut-and-cabochon-bezel-settings/15(1).png": 78541,
	"./rosecut-and-cabochon-bezel-settings/35(1).png": 64322,
	"./rosecut-and-cabochon-bezel-settings/55.png": 86960,
	"./rosecut-and-cabochon-bezel-settings/84(1).png": 57063,
	"./rosecut-and-cabochon-bezel-settings/9.png": 69940,
	"./rosecut-ring/37.png": 36453,
	"./rosecut-ring/38.png": 85060,
	"./rosecut-ring/39.png": 56519,
	"./rosecut-ring/40.png": 51845,
	"./sheet-wire/69.png": 72556,
	"./sheet-wire/70.png": 36771,
	"./sheet-wire/71.png": 8272,
	"./sheet-wire/72.png": 55834,
	"./signet-ring/29.png": 75450,
	"./signet-ring/30.png": 54063,
	"./signet-ring/32.png": 58089,
	"./signet-ring/33.png": 87433,
	"./soft-wax-bezel-settings/83.png": 33091,
	"./soft-wax-bezel-settings/84.png": 79049,
	"./soft-wax-bezel-settings/85.png": 87719,
	"./soft-wax-bezel-settings/86.png": 41233,
	"./solitaire-ring-with-fitted-bands/22.png": 63098,
	"./solitaire-ring-with-fitted-bands/23.png": 94554,
	"./solitaire-ring-with-fitted-bands/24.png": 90192,
	"./solitaire-ring-with-fitted-bands/25.png": 43778,
	"./solitaire-ring-with-fitted-bands/26.png": 43956,
	"./stacking-rings/10.png": 2533,
	"./stacking-rings/7.png": 27639,
	"./stacking-rings/8.png": 76989,
	"./stacking-rings/9.png": 24555,
	"./swivel-rings/79.png": 74980,
	"./swivel-rings/80.png": 24781,
	"./swivel-rings/81.png": 49833,
	"./swivel-rings/82.png": 59921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77637;